define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SkillSetService = void 0;
    class SkillSetService {
        constructor(httpRequest) {
            this.httpRequest = httpRequest;
        }
        list(pageSize, lastKey) {
            return this.httpRequest.request({
                method: 'GET',
                path: `/skillSet`,
                query: {
                    'pageSize': pageSize,
                    'lastKey': lastKey,
                },
                errors: {
                    400: `Bad Request`,
                    401: `Unauthorized`,
                    404: `Not Found`,
                    405: `Method Not Found`,
                    500: `Internal Server Error`,
                },
            });
        }
        create(requestBody) {
            return this.httpRequest.request({
                method: 'POST',
                path: `/skillSet`,
                body: requestBody,
                mediaType: 'application/json',
                errors: {
                    400: `Bad Request`,
                    401: `Unauthorized`,
                    404: `Not Found`,
                    405: `Method Not Found`,
                    500: `Internal Server Error`,
                },
            });
        }
        fetch(skillSetId) {
            return this.httpRequest.request({
                method: 'GET',
                path: `/skillSet/${skillSetId}`,
                errors: {
                    400: `Bad Request`,
                    401: `Unauthorized`,
                    404: `Not Found`,
                    405: `Method Not Found`,
                    500: `Internal Server Error`,
                },
            });
        }
        update(skillSetId, requestBody) {
            return this.httpRequest.request({
                method: 'PATCH',
                path: `/skillSet/${skillSetId}`,
                body: requestBody,
                mediaType: 'application/json',
                errors: {
                    400: `Bad Request`,
                    401: `Unauthorized`,
                    404: `Not Found`,
                    405: `Method Not Found`,
                    500: `Internal Server Error`,
                },
            });
        }
        remove(skillSetId) {
            return this.httpRequest.request({
                method: 'DELETE',
                path: `/skillSet/${skillSetId}`,
                errors: {
                    400: `Bad Request`,
                    401: `Unauthorized`,
                    404: `Not Found`,
                    405: `Method Not Found`,
                    500: `Internal Server Error`,
                },
            });
        }
    }
    exports.SkillSetService = SkillSetService;
});
